import { api } from './api';

/**
 * Chat (M-chat) creator-side client. Each conversation here is one of THIS
 * creator's student threads (`seller_kind='creator'`, scoped server-side to the
 * creator's user id). Polling-first, same cadence as the other apps.
 *
 * A HOUSE creator has no threads of its own by design: its courses resolve to
 * the house inbox, where the tenant's staff already work.
 */

export type SenderKind = 'buyer' | 'seller';

export type CreatorConversationListItem = {
  id: string;
  sellerKind: 'house' | 'merchant' | 'creator';
  /** The student's name or email. */
  counterparty: string | null;
  productId: string | null;
  orderId: string | null;
  lastMessageAt: string | null;
  lastMessagePreview: string | null;
  lastMessageSenderKind: SenderKind | null;
  unread: boolean;
};

export type CreatorConversationsPage = {
  items: CreatorConversationListItem[];
  nextCursor: string | null;
};

export type ChatMessage = {
  id: string;
  senderKind: SenderKind;
  senderUserId: string | null;
  body: string;
  createdAt: string;
};

export type MessagesPage = { items: ChatMessage[]; nextCursor: string | null };

export async function listCreatorConversations(
  args: { limit?: number; cursor?: string } = {},
): Promise<CreatorConversationsPage> {
  const res = await api.get<CreatorConversationsPage>('/creator/conversations', { params: args });
  return res.data;
}

export async function getCreatorChatUnreadCount(): Promise<{ count: number }> {
  const res = await api.get<{ count: number }>('/creator/conversations/unread-count');
  return res.data;
}

export async function listCreatorChatMessages(
  conversationId: string,
  args: { limit?: number; cursor?: string } = {},
): Promise<MessagesPage> {
  const res = await api.get<MessagesPage>(`/creator/conversations/${conversationId}/messages`, {
    params: args,
  });
  return res.data;
}

export async function sendCreatorChatMessage(
  conversationId: string,
  body: string,
): Promise<ChatMessage> {
  const res = await api.post<ChatMessage>(`/creator/conversations/${conversationId}/messages`, {
    body,
  });
  return res.data;
}

export async function markCreatorConversationRead(conversationId: string): Promise<void> {
  await api.post(`/creator/conversations/${conversationId}/read`);
}
